import MapboxWidget from './MapboxWidget';


export default MapboxWidget;
